// extracted by mini-css-extract-plugin
module.exports = {"roomNamePopupWrapper":"RoomNamePopup_roomNamePopupWrapper__3etda","buttonHolderBottom":"RoomNamePopup_buttonHolderBottom__3Var7"};